import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix : icônes Leaflet par défaut cassées avec webpack — on les fournit via CDN
const DefaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

/**
 * Carte interactive Leaflet (OpenStreetMap) pour visualiser le bien.
 * Affiche un cercle de rayon `radius` (en mètres) autour du marqueur pour
 * matérialiser la zone d'influence (utile pour le banquier/visite).
 */
export const PropertyMap = ({ lat, lon, title, address, height = 360, radius = 250 }) => {
  if (lat == null || lon == null) {
    return (
      <div className="bg-zinc-950 border border-zinc-800 rounded-lg p-6 text-center">
        <p className="text-sm text-zinc-500">
          Géolocalisation indisponible.<br />
          Ré-éditez le bien et choisissez une adresse depuis l'autocomplétion pour activer la carte.
        </p>
      </div>
    );
  }
  return (
    <div className="rounded-lg overflow-hidden border border-zinc-800" style={{ height }}>
      <MapContainer
        center={[lat, lon]}
        zoom={16}
        scrollWheelZoom={true}
        style={{ height: '100%', width: '100%' }}
        data-testid="property-map"
      >
        <TileLayer
          attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[lat, lon]}>
          <Popup>
            <strong>{title || 'Bien'}</strong>
            {address && <><br />{address}</>}
            <br /><span style={{ fontSize: 11, color: '#666' }}>{lat.toFixed(5)}, {lon.toFixed(5)}</span>
          </Popup>
        </Marker>
        <Circle center={[lat, lon]} radius={radius} pathOptions={{ color: '#10B981', fillOpacity: 0.08 }} />
      </MapContainer>
    </div>
  );
};
